import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function GastroDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Gastrointestinal Disorder Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please confirm the exact diagnosis:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <p>{questions.diagnosis.subQuestions.exactDiagnosis}</p>

                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosis.subQuestions.dateOfDiagnosis)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please provide details of all symptoms in the last 5 years to include:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.symptoms.referToAttachments}>
                        <br />
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question>Frequency:</Question>
                                <p>{questions.symptoms.subQuestions.frequency}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>

                        <QuestionsContainer>
                            <QuestionWrapper number='b'>
                                <Question>Severity:</Question>
                                <p>{questions.symptoms.subQuestions.severity}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>

                        <QuestionsContainer>
                            <QuestionWrapper number='c'>
                                <Question>Duration:</Question>
                                <p>{questions.symptoms.subQuestions.duration}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>

                        <QuestionsContainer>
                            <QuestionWrapper number='d'>
                                <Question>Date of last symptoms:</Question>
                                <p>{formatDateMonthYear(questions.symptoms.subQuestions.dateOfLastSymptoms)}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide the date and results of investigations in the last 5 years to include scopes, scans, bloods etc:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <OutputDetails
                            details={questions.investigations.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please provide details of any treatment in the last 5 years and the response to that treatment:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <p>{questions.treatmentProvided.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Are there any ongoing symptoms or limitations?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anySymptomsOngoing.referToAttachments}>
                        <p>{questions.anySymptomsOngoing.value}</p>
                        {questions.anySymptomsOngoing.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anySymptomsOngoing.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Has your patient required time off work due to this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyTimeOffWorkCaused.referToAttachments}>
                        <p>{questions.anyTimeOffWorkCaused.value}</p>
                        {questions.anyTimeOffWorkCaused.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details of any time off work to include dates and duration:</Question>
                                <OutputDetails
                                    details={questions.anyTimeOffWorkCaused.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}